import { PrivateBetaBadge } from '~/components/dialogs/settings/PrivateBetaBadge';
import { classNames } from '~/utils/classNames';

type Props = {
  title: string;
  icon: string;
  description: string;
  className?: string;
};

export const PrivateBetaScreen = ({ title, icon, description, className }: Props) => {
  return (
    <div className={classNames('flex flex-col gap-4 items-center justify-center h-full', className)}>
      <div className="size-20 flex items-center justify-center rounded-full bg-bolt-ds-surfaceTwo">
        <div className={classNames(icon, 'text-bolt-ds-text-secondary size-10 text-bolt-ds-textTertiary')} />
      </div>
      <div className="flex flex-col items-center text-center gap-3">
        <h3 className="text-base font-semibold">{title}</h3>
        <p className="text-bolt-ds-text-secondary text-sm max-w-130">{description}</p>
      </div>
      <PrivateBetaBadge />
    </div>
  );
};
